import { TypedStorage } from 'modules/typed-storage';

const PREFIX = 'RAZ_LANGUAGE_ID';
type LanguageStorage = {
  languageID: string | null;
};

export const languagesStorage = new TypedStorage<LanguageStorage>(PREFIX, '0.0.1');
